// src/pages/Menu/Articulacion/Documents/DeleteProjectModal.jsx
import React from "react";
import { Trash2, X } from "lucide-react";

export default function DeleteProjectModal({
  open,
  projectTitle,
  onClose,
  onConfirm,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} aria-hidden />
      <div className="absolute inset-0 grid place-items-center p-6">
        <div
          className="rounded-2xl p-[2px]"
          style={{ background: "linear-gradient(135deg,#E6F0FF 0%,#E6FBFF 100%)" }}
        >
          <div className="w-[min(92vw,34rem)] rounded-2xl overflow-hidden bg-white ring-1 ring-black/5">
            <div
              className="px-5 py-4 text-white"
              style={{ background: "linear-gradient(90deg,#0c3b66,#0488AF)" }}
            >
              <div className="flex items-center justify-between">
                <div className="font-semibold text-base">Eliminar proyecto</div>
                <button
                  className="p-2 rounded-lg hover:bg-white/10"
                  onClick={onClose}
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>

            <div className="px-5 py-4 space-y-2">
              <p className="text-sm text-gray-700">
                ¿Estás seguro de que deseas eliminar este proyecto?
              </p>
              {projectTitle && (
                <p className="text-sm font-medium text-gray-900">
                  “{projectTitle}”
                </p>
              )}
              <p className="text-xs text-gray-500">
                Esta acción eliminará el proyecto y sus minutas asociadas. No se
                puede deshacer.
              </p>
            </div>

            <div className="px-5 py-3 border-t border-gray-200 bg-white flex justify-end gap-2">
              <button
                onClick={onClose}
                className="h-11 px-4 rounded-xl bg-[#C42251] text-white hover:bg-[#A01D45] text-sm font-semibold transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={onConfirm}
                className="inline-flex items-center gap-2 h-11 px-4 rounded-xl bg-[#C42251] text-white hover:bg-[#A01D45] text-sm font-semibold transition-colors"
              >
                <Trash2 className="w-4 h-4" />
                Eliminar definitivamente
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}